import userFriendlyEr from '../../../utils/userFriendlyEr.js'

export default {
  data () {
    return {
      username: '',
      password: '',
      loading: false,
      error: null
    }
  },
  computed: {
    globalError () {
      return this.$store.getters.getError
    }
  },
  watch: {
    'globalError': 'onGlobalError'
  },
  methods: {
    onGlobalError () {
      // if auotrization error, unset error for show login form
      if (this.globalError && this.globalError.status === 401) {
        this.$store.commit('mutateError', null)
      }
    },
    onSubmit () {
      this.loading = true
      this.error = null
      this.$store.dispatch('userLogin', {
        username: this.username.trim(),
        password: this.password.trim()
      }).then(r => {
        console.log('redirectUrl', this.$store.getters.redirectUrl)
        this.$router.push(this.$store.getters.redirectUrl)
      }).catch(e => {
        console.warn('Login error', e)
        this.error = userFriendlyEr.recognize(e)
        this.loading = false
      })
    }
  },
  asyncData () {
    return Promise.resolve(1)
  }
}
